import React, { useEffect, useMemo } from "react";
import useTranslator from "../../../hooks/useTranslator";

interface ReviewScreenProps {
  image: File | Blob;
  side: "front" | "back";
  error: string | null;
  onConfirm: () => void;
  onRetake: () => void;
}

const ReviewScreen: React.FC<ReviewScreenProps> = ({
  image,
  side,
  error,
  onConfirm,
  onRetake,
}) => {
  const { _t } = useTranslator();

  const imageUrl = useMemo(() => URL.createObjectURL(image), [image]);

  useEffect(() => () => URL.revokeObjectURL(imageUrl), [imageUrl]);

  return (
    <div className="mobile-capture-review-screen">
      <div className="mobile-capture-review-header">
        <span>{_t("Photo ready")}</span>
        <h3>
          {side === "front"
            ? _t("mobileCaptureReviewFront")
            : _t("mobileCaptureReviewBack")}
        </h3>
      </div>

      <div className="mobile-capture-review-image">
        <img src={imageUrl} alt={_t("mobileCaptureCapturedImage")} />
      </div>

      {error && (
        <div className="mobile-capture-review-error">
          <p>{error}</p>
        </div>
      )}

      <div className="mobile-capture-review-actions">
        <button
          type="button"
          className="mobile-capture-btn mobile-capture-btn-secondary"
          onClick={onRetake}
        >
          {_t("Redo")}
        </button>
        <button
          type="button"
          className="mobile-capture-btn mobile-capture-btn-primary"
          onClick={onConfirm}
        >
          {_t("mobileCaptureUsePhoto")}
        </button>
      </div>
    </div>
  );
};

export default ReviewScreen;
